import React from 'react';

import EndOfArticleDeepResearch from '@components/pages/Article/EndOfArticle/DeepResearch';
import LegacyDeepResearch from '@components/pages/Article/MidArticle/DeepResearch';
import { useArticleDeepResearchPrompts } from '@hooks/useArticleDeepResearchPrompts';
import useNativeAppVersionCheck from '@hooks/useNativeAppVersionCheck';
import { useSuggestedAiPrompts } from '@hooks/useSuggestedAiPrompts';

interface MidArticleDeepResearchUnitProps {
  articleId: number;
}

// Legacy native apps (< 3.0): user-level suggestedAiPrompts take precedence.
// Web / modern native apps: article-specific deep research prompts.
const MidArticleDeepResearchUnit = ({ articleId }: MidArticleDeepResearchUnitProps) => {
  const { isApp3_0OrGreater, isNativeApp } = useNativeAppVersionCheck();
  const isLegacyNativeApp = isNativeApp && !isApp3_0OrGreater;

  const { suggestedAiPrompts } = useSuggestedAiPrompts();
  const { prompts } = useArticleDeepResearchPrompts(articleId);

  if (isLegacyNativeApp && suggestedAiPrompts?.length) return <LegacyDeepResearch />;
  if (!isLegacyNativeApp && prompts?.length) return <EndOfArticleDeepResearch id={articleId} />;
  return null;
};

export default MidArticleDeepResearchUnit;
